import '../css/community.css';
import '../css/wa.css';
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { IoTimeOutline, IoHeart } from "react-icons/io5";
import { FaCommentAlt } from "react-icons/fa";
import axios from "axios";
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import BoxHandler from '../components/BoxHandler.js';
import HeadlineCarousel from '../components/headline';

function Community() {
    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const getCategories = async () => {
            try {
                const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/category/fetch`, {});
                setCategories(data.categories);
                console.log(data.categories);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };
        getCategories();
    }, []);

    const goToCategory = (code) => {
        navigate('/community/' + code);
    };

    return (
        <>
            <div className='cm-category-banner'>
                <div className='category selected' onClick={() => goToCategory('')}>커뮤니티 홈</div>
                {categories.map((ct) => (
                    <div className='category' id={ct.id} onClick={() => goToCategory(ct.id)}>
                        {ct.name}
                    </div>
                ))}
            </div>
            <div className='ma-18'>
                <div className='cm-banner'>
                    <HeadlineCarousel />
                </div>
                <div className='cm-categories'>
                

                    {categories.map((category) => (
                        <div key={category.id} className='wa-card'>
                        {category.name && category.articles ? (
                            <BoxHandler 
                            options={{
                                title: category.name,
                                tabs: ['인기글 보기', '최신글 보기']
                            }}
                            titleRight={<MdOutlineArrowForwardIos onClick={() => window.location.href = `/community/${category.id}`} className='wa-title-into' />}
                            >
                            <div id='1'>
                                <div className="cm-card-sec-a">
                                        {category.hotArticles.map((article) => (
                                            <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                                            {article.previewImage ? 
                                            <div className="cm-card-list-item-thumb wa-thumb"><img src={article.previewImage}></img></div>
                                            : null }
                                            <div className="cm-card-list-item-content">
                                                <div className="cm-card-list-item-title">
                                                <span style={{ fontWeight: 600, color: article.headColor }}>
                                                    [{article.headName}] 
                                                </span>
                                                {article.title}
                                                </div>
                                                <div className="cm-card-list-item-meta">
                                                <IoTimeOutline />
                                                <span className="meta-time">{article.date}</span>
                                                <span className="meta-divider">·</span>
                                                <span className="meta-likes">
                                                    <IoHeart />
                                                    {article.like}
                                                </span>
                                                <span className="meta-divider">·</span>
                                                <span className="meta-comments">
                                                    <FaCommentAlt className='icon-smaller' />
                                                    {article.commentCount}
                                                </span>
                                                </div>
                                            </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                            <div id='2'>
                                <div className="cm-card-sec-a">
                                    {category.articles.map((article) => (
                                        <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                                        <div className="cm-card-list-item-thumb wa-thumb">
                                            <img src={article.previewImage} />
                                        </div>
                                        <div className="cm-card-list-item-content">
                                            <div className="cm-card-list-item-title">
                                            <span style={{ fontWeight: 600, color: article.headColor }}>
                                                [{article.headName}] 
                                            </span>
                                            {article.title}
                                            </div>
                                            <div className="cm-card-list-item-meta">
                                            <IoTimeOutline />
                                            <span className="meta-time">{article.date}</span>
                                            <span className="meta-divider">·</span>
                                            <span className="meta-likes">
                                                <IoHeart />
                                                {article.like}
                                            </span>
                                            <span className="meta-divider">·</span>
                                            <span className="meta-comments">
                                                <FaCommentAlt className='icon-smaller' />
                                                {article.commentCount}
                                            </span>
                                            </div>
                                        </div>
                                        </div>
                                    ))}

                                </div>
                            </div>
                            </BoxHandler>
                        ) : null}
                        </div>
                    ))}
                    

                </div>
            </div>
        </>
    );
}

export default Community;
